import { render } from "./Cog.vue?vue&type=template&id=48a6de46&scoped=true"
import script from "./Cog.vue?vue&type=script&lang=js"
export * from "./Cog.vue?vue&type=script&lang=js"

import "./Cog.vue?vue&type=style&index=0&id=48a6de46&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a6de46"]])

export default __exports__